import { API } from "../../api";
async function create_send_otp(request) {
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/create/send/otp`,
        content: request,
    });
}
export { create_send_otp };
